import { useGroupDashboardContext } from '../../../GroupDashboardContext'
import { SelectedUser } from '../../types/userDetails'
import { getPrettyDate, isTimestamp } from '../../utils'

type CourseContent = {
  course_id: string,
  course_title: string
}

type CourseData = {
  courses: CourseContent[]
}

export type EnrolledCoursesData = {
  courseId: string
  course: string
  dateCompleted: string
  completePercentage: string
  avgQuizScore: string
}[]

// Convert the data for it to be mapped ready on Tanstack Table.
const parseToUserEnrolledCourses = (courses: CourseData, selectedUser: SelectedUser) => {

  const { selectedTeamType } = useGroupDashboardContext()
  let results =  []
    courses.map((course:CourseContent, key:number) => {
      const progress = selectedUser.progress.find(p => Number(p.course_id) === Number( course.course_id))

      if ( progress || selectedTeamType === 'wooteams' ) {

        const completePercentage = progress
        ? Math.trunc(Number(progress.completeness_percentage)).toString()
        : '0'
        const dateCompleted =  progress && isTimestamp(progress.course_completed)
        ? getPrettyDate( progress.course_completed )
        : '-'
        const avgQuizScore = '0'
        const certificateLink = progress?.certificate_link ? progress.certificate_link : ""
  
        results.push({
          courseId: course.course_id,
          course: course.course_title,
          dateCompleted,
          completePercentage,
          avgQuizScore,
          certificateLink
        })
      }
    })
    return results
}
  
export const CoursesEnrolledReportData = (courses: CourseData, selectedUser: SelectedUser) => {
    return parseToUserEnrolledCourses(courses, selectedUser)
}
